export default __webpack_public_path__ + "static/media/line-seq-swap-arrow-down-white.97886b63.svg";